/**
 * Shared keyboard focus ring. Composed into interactive primitives via cn().
 * Centralized so the focus treatment changes in one place.
 */
export const FOCUS_RING =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2";
